module.exports = __webpack_public_path__ + "static/media/promo.5a490695.png";